import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const FloatingActionButton = ({ userRole = 'boss' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const shouldShow = userRole === 'boss' && location?.pathname === '/boss-home-page';

  if (!shouldShow) {
    return null;
  }

  const handleClick = () => {
    navigate('/project-creation');
  };

  const buttonSize = isMobile ? 'w-14 h-14' : 'w-16 h-16';
  const iconSize = isMobile ? 24 : 28;
  const bottomPosition = isMobile ? 'bottom-20' : 'bottom-6';

  return (
    <button
      onClick={handleClick}
      className={`fixed ${bottomPosition} right-6 ${buttonSize} bg-primary hover:bg-primary/90 text-primary-foreground rounded-full shadow-elevated hover:shadow-lg transition-smooth z-[200] flex items-center justify-center group`}
      aria-label="Create new project"
      title="Create new project"
    >
      <Icon 
        name="Plus" 
        size={iconSize} 
        strokeWidth={2.5}
        className="group-hover:scale-110 transition-transform duration-200"
      />
    </button>
  );
};

export default FloatingActionButton;